// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.vod_uploadbox+.video-list {\n\topacity: 1;\n\ttransition: .3s;\n}\n.vod_uploadbox:has(.drop-zone-hidden_dragover)+.video-list {\n\topacity: 0;\n\ttransition: .3s;\n}\n.no-shadow {\n\tbox-shadow: none;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
